import GetGatheringForReactionAssetDocument from "src/api/graphql/__generated__/documents/GetGatheringForReactionAssetDocument";
import parseReactionAssetTemplateUrl from "src/helpers/parseV0TemplateUrl/parseReactionAssetTemplateUrl";
import IconLocation from "src/icons/IconLocation";
import IconTag from "src/icons/IconTag";
import { getGlobalStore } from "src/stores/useGlobalStore";
import { GatheringFilterSortSectionOption } from "../../../types";

const fetchLabelDataToOption = async ({
	label,
	numPhotos,
	visibility,
	gatheringId,
}: {
	label: string;
	numPhotos: number;
	visibility: string;

	// Context
	gatheringId: string;
}): Promise<GatheringFilterSortSectionOption | null> => {
	// $ is a special character which has special data requirements
	// We can handle all non-special cases first
	if (!label.startsWith("$")) {
		return {
			id: `${visibility}-${label}`,
			text: label,
			Icon: IconTag,
		};
	}
	const apolloClient = getGlobalStore().apolloClient;
	// Add special handling here eventually
	if (label === "$Reacted") {
		if (!apolloClient) return null;
		const { data } = await apolloClient.query({
			query: GetGatheringForReactionAssetDocument,
			variables: {
				input: {
					gatheringId,
				},
			},
		});
		const reactionAssetUrl = parseReactionAssetTemplateUrl({
			readUrl: data?.getGathering?.reactionAsset?.url,
		});
		if (data?.getGathering?.reactionAsset?.emoji) {
			return {
				id: `${visibility}-${label}`,
				text: "Reacted",
				emoji: data.getGathering.reactionAsset.emoji,
			};
		} else if (reactionAssetUrl) {
			// Not currently supported
			return null;
		}
	}
	if (label.startsWith("$Landmark#")) {
		const landmarkText = label.replace("$Landmark#", "");
		return {
			id: `${visibility}-${label}`,
			text: landmarkText,
			Icon: IconLocation,
		};
	}
	if (label.startsWith("$Orientation#")) {
		const orientationText = label.replace("$Orientation#", "");
		return {
			id: `${visibility}-${label}`,
			text: orientationText,
			Icon: IconTag,
		};
	}

	// Don't throw if we don't know how to handle a certain special case
	// Likely just a new label type that the frontend client doesn't know how to handle
	return null;
};
export default fetchLabelDataToOption;
